/*! SKPlayer */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("skPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["skPlayer"] = factory();
	else
		root["skPlayer"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//SKPlayer
console.log('%cSKPlayer 3.0.7', 'color:#D94240');

__webpack_require__(1);

var Util = {
    leftDistance: function leftDistance(el) {
        var left = el.offsetLeft;
        var scrollLeft = void 0;
        while (el.offsetParent) {
            el = el.offsetParent;
            left += el.offsetLeft;
        }
        scrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
        return left - scrollLeft;
    },
    timeFormat: function timeFormat(time) {
        var tempMin = parseInt(time / 60);
        var tempSec = parseInt(time % 60);
        var curMin = tempMin < 10 ? '0' + tempMin : tempMin;
        var curSec = tempSec < 10 ? '0' + tempSec : tempSec;
        return curMin + ':' + curSec;
    },
    percentFormat: function percentFormat(percent) {
        return (percent * 100).toFixed(2) + '%';
    },
    ajax: function ajax(option) {
        option.beforeSend && option.beforeSend();
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    option.success && option.success(xhr.responseText);
                } else {
                    option.fail && option.fail(xhr.status);
                }
            }
        };
        xhr.open('GET', option.url);
        xhr.send(null);
    }
};

var instance = false;
var baseUrl = 'http://163.opdays.com/';

var skPlayer = function () {
    function skPlayer(option) {
        var _this = this;

        _classCallCheck(this, skPlayer);

        if (instance) {
            console.error('SKPlayer只能存在一个实例！');
            return Object.create(null);
        } else {
            instance = true;
        }

        var defaultOption = {
            element: document.getElementById('skPlayer'),
            autoplay: false, //true/false
            mode: 'listloop', //singleloop/listloop
            listshow: true //true/false
        };
        // this.option = Object.assign({},defaultOption,option);
        for (var defaultKey in defaultOption) {
            if (!option.hasOwnProperty(defaultKey)) {
                option[defaultKey] = defaultOption[defaultKey];
            }
        }
        this.option = option;

        if (!(this.option.music && this.option.music.type && this.option.music.source)) {
            console.error('请正确配置对象！');
            return Object.create(null);
        }
        this.root = this.option.element;
        this.type = this.option.music.type;
        this.music = this.option.music.source;
        this.isMobile = /mobile/i.test(window.navigator.userAgent);

        this.toggle = this.toggle.bind(this);
        this.toggleList = this.toggleList.bind(this);
        this.toggleMute = this.toggleMute.bind(this);
        this.switchMode = this.switchMode.bind(this);

        if (this.type === 'file') {
            this.root.innerHTML = this.template();
            this.init();
            this.bind();
        } else if (this.type === 'cloud') {
            this.root.innerHTML = '<p class="skPlayer-tip-loading">LOADING</p>';
            Util.ajax({
                url: baseUrl + 'playlist?id=' + this.music,
                beforeSend: function beforeSend() {
                    console.log('SKPlayer正在努力的拉取歌单 ...');
                },
                success: function success(data) {
                    console.log('歌单拉取成功！');
                    _this.music = JSON.parse(data);
                    _this.root.innerHTML = _this.template();
                    _this.init();
                    _this.bind();
                },
                fail: function fail(status) {
                    console.error('歌单拉取失败！ 错误码：' + status);
                }
            });
        }
    }

    _createClass(skPlayer, [{
        key: 'template',
        value: function template() {
            var html = '\n            <audio class="skPlayer-source" src="' + (this.type === 'file' ? this.music[0].src : '') + '" preload="auto"></audio>\n            <div class="skPlayer-picture">\n                <img class="skPlayer-cover" src="' + this.music[0].cover + '" alt="">\n                <a href="javascript:;" class="skPlayer-play-btn">\n                    <span class="skPlayer-left"></span>\n                    <span class="skPlayer-right"></span>\n                </a>\n            </div>\n            <div class="skPlayer-control">\n                <p class="skPlayer-name">' + this.music[0].name + '</p>\n                <p class="skPlayer-author">' + this.music[0].author + '</p>\n                <div class="skPlayer-percent">\n                    <div class="skPlayer-line-loading"></div>\n                    <div class="skPlayer-line"></div>\n                </div>\n                <p class="skPlayer-time">\n                    <span class="skPlayer-cur">' + '00:00' + '</span>/<span class="skPlayer-total">' + '00:00' + '</span>\n                </p>\n                <div class="skPlayer-volume" style="' + (this.isMobile ? 'display:none;' : '') + '">\n                    <i class="skPlayer-icon"></i>\n                    <div class="skPlayer-percent">\n                        <div class="skPlayer-line"></div>\n                    </div>\n                </div>\n                <div class="skPlayer-list-switch">\n                    <i class="skPlayer-list-icon"></i>\n                </div>\n                <i class="' + (this.option.mode === 'singleloop' ? 'skPlayer-mode skPlayer-mode-loop' : 'skPlayer-mode') + '"></i>\n            </div>\n            <ul class="skPlayer-list">\n        ';
            for (var index in this.music) {
                html += '\n                <li data-index="' + index + '">\n                    <i class="skPlayer-list-sign"></i>\n                    <span class="skPlayer-list-index">' + (parseInt(index) + 1) + '</span>\n                    <span class="skPlayer-list-name" title="' + this.music[index].name + '">' + this.music[index].name + '</span>\n                    <span class="skPlayer-list-author" title="' + this.music[index].author + '">' + this.music[index].author + '</span>\n                </li>\n            ';
            }
            html += '\n            </ul>\n        ';
            return html;
        }
    }, {
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.dom = {
                cover: this.root.querySelector('.skPlayer-cover'),
                playbutton: this.root.querySelector('.skPlayer-play-btn'),
                name: this.root.querySelector('.skPlayer-name'),
                author: this.root.querySelector('.skPlayer-author'),
                timeline_total: this.root.querySelector('.skPlayer-percent'),
                timeline_loaded: this.root.querySelector('.skPlayer-line-loading'),
                timeline_played: this.root.querySelector('.skPlayer-percent .skPlayer-line'),
                timetext_total: this.root.querySelector('.skPlayer-total'),
                timetext_played: this.root.querySelector('.skPlayer-cur'),
                volumebutton: this.root.querySelector('.skPlayer-icon'),
                volumeline_total: this.root.querySelector('.skPlayer-volume .skPlayer-percent'),
                volumeline_value: this.root.querySelector('.skPlayer-volume .skPlayer-line'),
                switchbutton: this.root.querySelector('.skPlayer-list-switch'),
                modebutton: this.root.querySelector('.skPlayer-mode'),
                musiclist: this.root.querySelector('.skPlayer-list'),
                musicitem: this.root.querySelectorAll('.skPlayer-list li')
            };
            this.audio = this.root.querySelector('.skPlayer-source');
            if (this.option.listshow) {
                this.root.className = 'skPlayer-list-on';
            }
            if (this.option.mode === 'singleloop') {
                this.audio.loop = true;
            }
            this.dom.musicitem[0].className = 'skPlayer-curMusic';
            if (this.type === 'cloud') {
                Util.ajax({
                    url: baseUrl + 'song/detail?id=' + this.music[0].song_id,
                    beforeSend: function beforeSend() {
                        console.log('SKPlayer正在努力的拉取歌曲 ...');
                    },
                    success: function success(data) {
                        console.log('歌曲拉取成功！');
                        var url = JSON.parse(data).url;
                        _this2.audio.src = url;
                    },
                    fail: function fail(status) {
                        console.error('歌曲拉取失败！ 错误码：' + status);
                    }
                });
            }
        }
    }, {
        key: 'bind',
        value: function bind() {
            var _this3 = this;

            this.updateLine = function () {
                var percent = _this3.audio.buffered.length ? _this3.audio.buffered.end(_this3.audio.buffered.length - 1) / _this3.audio.duration : 0;
                _this3.dom.timeline_loaded.style.width = Util.percentFormat(percent);
            };

            this.audio.addEventListener('durationchange', function (e) {
                _this3.dom.timetext_total.innerHTML = Util.timeFormat(_this3.audio.duration);
                _this3.updateLine();
            });
            this.audio.addEventListener('progress', function (e) {
                _this3.updateLine();
            });
            this.audio.addEventListener('canplay', function (e) {
                if (_this3.option.autoplay && !_this3.isMobile) {
                    _this3.play();
                }
            });
            this.audio.addEventListener('timeupdate', function (e) {
                var percent = _this3.audio.currentTime / _this3.audio.duration;
                _this3.dom.timeline_played.style.width = Util.percentFormat(percent);
                _this3.dom.timetext_played.innerHTML = Util.timeFormat(_this3.audio.currentTime);
            });
            this.audio.addEventListener('seeked', function (e) {
                _this3.play();
            });
            this.audio.addEventListener('ended', function (e) {
                _this3.next();
            });

            this.dom.playbutton.addEventListener('click', this.toggle);
            this.dom.switchbutton.addEventListener('click', this.toggleList);
            if (!this.isMobile) {
                this.dom.volumebutton.addEventListener('click', this.toggleMute);
            }
            this.dom.modebutton.addEventListener('click', this.switchMode);
            this.dom.musiclist.addEventListener('click', function (e) {
                var target = void 0,
                    index = void 0,
                    curIndex = void 0;
                if (e.target.tagName.toUpperCase() === 'LI') {
                    target = e.target;
                } else if (e.target.parentElement.tagName.toUpperCase() === 'LI') {
                    target = e.target.parentElement;
                } else {
                    return;
                }
                index = parseInt(target.getAttribute('data-index'));
                curIndex = parseInt(_this3.dom.musiclist.querySelector('.skPlayer-curMusic').getAttribute('data-index'));
                if (index === curIndex) {
                    _this3.play();
                } else {
                    _this3.switchMusic(index + 1);
                }
            });
            this.dom.timeline_total.addEventListener('click', function (event) {
                var e = event || window.event;
                var percent = (e.clientX - Util.leftDistance(_this3.dom.timeline_total)) / _this3.dom.timeline_total.clientWidth;
                if (!isNaN(_this3.audio.duration)) {
                    _this3.dom.timeline_played.style.width = Util.percentFormat(percent);
                    _this3.dom.timetext_played.innerHTML = Util.timeFormat(percent * _this3.audio.duration);
                    _this3.audio.currentTime = percent * _this3.audio.duration;
                }
            });
            if (!this.isMobile) {
                this.dom.volumeline_total.addEventListener('click', function (event) {
                    var e = event || window.event;
                    var percent = (e.clientX - Util.leftDistance(_this3.dom.volumeline_total)) / _this3.dom.volumeline_total.clientWidth;
                    _this3.dom.volumeline_value.style.width = Util.percentFormat(percent);
                    _this3.audio.volume = percent;
                    if (_this3.audio.muted) {
                        _this3.toggleMute();
                    }
                });
            }
        }
    }, {
        key: 'prev',
        value: function prev() {
            var index = parseInt(this.dom.musiclist.querySelector('.skPlayer-curMusic').getAttribute('data-index'));
            if (index === 0) {
                if (this.music.length === 1) {
                    this.play();
                } else {
                    this.switchMusic(this.music.length - 1 + 1);
                }
            } else {
                this.switchMusic(index - 1 + 1);
            }
        }
    }, {
        key: 'next',
        value: function next() {
            var index = parseInt(this.dom.musiclist.querySelector('.skPlayer-curMusic').getAttribute('data-index'));
            if (index === this.music.length - 1) {
                if (this.music.length === 1) {
                    this.play();
                } else {
                    this.switchMusic(0 + 1);
                }
            } else {
                this.switchMusic(index + 1 + 1);
            }
        }
    }, {
        key: 'switchMusic',
        value: function switchMusic(index) {
            var _this4 = this;

            if (typeof index !== 'number') {
                console.error('请输入正确的歌曲序号！');
                return;
            }
            index -= 1;
            if (index < 0 || index >= this.music.length) {
                console.error('请输入正确的歌曲序号！');
                return;
            }
            if (index == this.dom.musiclist.querySelector('.skPlayer-curMusic').getAttribute('data-index')) {
                this.play();
                return;
            }
            //if(!this.isMobile){
            //    this.audio.pause();
            //    this.audio.currentTime = 0;
            //}
            this.dom.musiclist.querySelector('.skPlayer-curMusic').classList.remove('skPlayer-curMusic');
            this.dom.musicitem[index].classList.add('skPlayer-curMusic');
            this.dom.name.innerHTML = this.music[index].name;
            this.dom.author.innerHTML = this.music[index].author;
            this.dom.cover.src = this.music[index].cover;
            if (this.type === 'file') {
                this.audio.src = this.music[index].src;
                this.play();
            } else if (this.type === 'cloud') {
                Util.ajax({
                    url: baseUrl + 'song/detail?id=' + this.music[index].song_id,
                    beforeSend: function beforeSend() {
                        console.log('SKPlayer正在努力的拉取歌曲 ...');
                    },
                    success: function success(data) {
                        console.log('歌曲拉取成功！');
                        var url = JSON.parse(data).url;
                        _this4.audio.src = url;
                        _this4.play();
                        //暂存问题，移动端兼容性
                    },
                    fail: function fail(status) {
                        console.error('歌曲拉取失败！ 错误码：' + status);
                    }
                });
            }
        }
    }, {
        key: 'play',
        value: function play() {
            if (this.audio.paused) {
                this.audio.play();
                this.dom.playbutton.classList.add('skPlayer-pause');
                this.dom.cover.classList.add('skPlayer-pause');
            }
        }
    }, {
        key: 'pause',
        value: function pause() {
            if (!this.audio.paused) {
                this.audio.pause();
                this.dom.playbutton.classList.remove('skPlayer-pause');
                this.dom.cover.classList.remove('skPlayer-pause');
            }
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            this.audio.paused ? this.play() : this.pause();
        }
    }, {
        key: 'toggleList',
        value: function toggleList() {
            this.root.classList.contains('skPlayer-list-on') ? this.root.classList.remove('skPlayer-list-on') : this.root.classList.add('skPlayer-list-on');
        }
    }, {
        key: 'toggleMute',
        value: function toggleMute() {
            //暂存问题，移动端兼容性
            if (this.audio.muted) {
                this.audio.muted = false;
                this.dom.volumebutton.classList.remove('skPlayer-quiet');
                this.dom.volumeline_value.style.width = Util.percentFormat(this.audio.volume);
            } else {
                this.audio.muted = true;
                this.dom.volumebutton.classList.add('skPlayer-quiet');
                this.dom.volumeline_value.style.width = '0%';
            }
        }
    }, {
        key: 'switchMode',
        value: function switchMode() {
            if (this.audio.loop) {
                this.audio.loop = false;
                this.dom.modebutton.classList.remove('skPlayer-mode-loop');
            } else {
                this.audio.loop = true;
                this.dom.modebutton.classList.add('skPlayer-mode-loop');
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            instance = false;
            this.audio.pause();
            this.root.innerHTML = '';
            for (var prop in this) {
                delete this[prop];
            }
            console.log('该实例已销毁，可重新配置 ...');
        }
    }]);

    return skPlayer;
}();

module.exports = skPlayer;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./skPlayer.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./skPlayer.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "/*!\n    SKPlayer\n */\n#skPlayer {\n  width: 380px;\n  height: 100px;\n  font-family: Arial,Helvetica,sans-serif;\n  position: relative;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  cursor: default;\n  background-color: #FFF;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12); }\n  #skPlayer * {\n    margin: 0;\n    padding: 0;\n    box-sizing: content-box;\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box; }\n    #skPlayer *::before {\n      box-sizing: content-box;\n      -webkit-box-sizing: content-box;\n      -moz-box-sizing: content-box; }\n    #skPlayer *::after {\n      box-sizing: content-box;\n      -webkit-box-sizing: content-box;\n      -moz-box-sizing: content-box; }\n  #skPlayer .skPlayer-tip-loading {\n    font-size: 30px;\n    color: #6A6B6F;\n    line-height: 100px;\n    text-align: center; }\n  #skPlayer .skPlayer-picture {\n    width: 100px;\n    height: 100px;\n    float: left;\n    position: relative;\n    border-radius: 7px 0 0 5px;\n    z-index: 3; }\n  #skPlayer .skPlayer-cover {\n    width: 100%;\n    transition: 0.37s;\n    -webkit-transition: 0.37s;\n    -moz-transition: 0.37s; }\n    #skPlayer .skPlayer-cover.skPlayer-pause {\n      filter: blur(3px);\n      -webkit-filter: blur(3px); }\n  #skPlayer .skPlayer-play-btn {\n    display: block;\n    width: 60px;\n    height: 60px;\n    background-color: #D94240;\n    border-radius: 50%;\n    position: absolute;\n    overflow: hidden;\n    top: 50%;\n    left: 0;\n    transform: translate(-50%, -50%) translateZ(0);\n    -webkit-transform: translate(-50%, -50%) translateZ(0);\n    -moz-transform: translate(-50%, -50%) translateZ(0);\n    -ms-transform: translate(-50%, -50%) translateZ(0);\n    z-index: 2;\n    transition: 0.7s;\n    -webkit-transition: 0.7s;\n    -moz-transition: 0.7s; }\n    #skPlayer .skPlayer-play-btn.skPlayer-pause {\n      left: 50%; }\n      #skPlayer .skPlayer-play-btn.skPlayer-pause .skPlayer-left {\n        border: 14px solid #FFF;\n        border-left: 2px solid #FFF;\n        border-right: 2px solid #FFF; }\n      #skPlayer .skPlayer-play-btn.skPlayer-pause .skPlayer-right {\n        top: 16px; }\n    #skPlayer .skPlayer-play-btn span {\n      display: block;\n      width: 0;\n      height: 0;\n      position: absolute;\n      transition: 0.37s;\n      -webkit-transition: 0.37s;\n      -moz-transition: 0.37s;\n      transform: translateZ(0);\n      -webkit-transform: translateZ(0);\n      -moz-transform: translateZ(0);\n      -ms-transform: translateZ(0); }\n      #skPlayer .skPlayer-play-btn span.skPlayer-left {\n        border-left: 24px solid #FFF;\n        border-top: 14px solid transparent;\n        border-bottom: 14px solid transparent;\n        left: 21px;\n        top: 16px; }\n      #skPlayer .skPlayer-play-btn span.skPlayer-right {\n        border: 14px solid #FFF;\n        border-left: 2px solid #FFF;\n        border-right: 2px solid #FFF;\n        right: 21px;\n        top: -76px; }\n  #skPlayer .skPlayer-control {\n    width: 250px;\n    height: 75px;\n    padding: 10px 15px 15px;\n    background-color: transparent;\n    float: right;\n    border-radius: 0 7px 7px 0;\n    position: relative;\n    z-index: 2;\n    text-align: left; }\n    #skPlayer .skPlayer-control p {\n      line-height: 1.2;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n      #skPlayer .skPlayer-control p.skPlayer-name {\n        font-size: 18px;\n        font-weight: 700;\n        color: #6A6B6F; }\n      #skPlayer .skPlayer-control p.skPlayer-author {\n        font-size: 15px;\n        color: #666;\n        max-width: 90%; }\n    #skPlayer .skPlayer-control > .skPlayer-percent {\n      width: 250px;\n      height: 6px;\n      background-color: #EBEBF2;\n      margin: 9px 0;\n      cursor: pointer;\n      overflow: hidden;\n      position: relative; }\n      #skPlayer .skPlayer-control > .skPlayer-percent .skPlayer-line {\n        width: 0;\n        height: 100%;\n        background-color: #D94240;\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2; }\n      #skPlayer .skPlayer-control > .skPlayer-percent .skPlayer-line-loading {\n        width: 0;\n        height: 100%;\n        background-color: #D3D3E0;\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 1;\n        transition: 0.7s;\n        -webkit-transition: 0.7s;\n        -moz-transition: 0.7s;\n        transform: translateZ(0);\n        -webkit-transform: translateZ(0);\n        -moz-transform: translateZ(0);\n        -ms-transform: translateZ(0); }\n    #skPlayer .skPlayer-control .skPlayer-time {\n      font-size: 15px;\n      color: #666;\n      float: left; }\n    #skPlayer .skPlayer-control .skPlayer-volume {\n      width: 120px;\n      height: 14px;\n      float: right;\n      position: relative;\n      margin: 1px 24px 0 0; }\n      #skPlayer .skPlayer-control .skPlayer-volume .skPlayer-icon {\n        display: block;\n        width: 5px;\n        height: 6px;\n        position: absolute;\n        background-color: #6A6B6F;\n        top: 4px;\n        left: -20px;\n        cursor: pointer; }\n        #skPlayer .skPlayer-control .skPlayer-volume .skPlayer-icon.skPlayer-quiet::before {\n          display: block; }\n        #skPlayer .skPlayer-control .skPlayer-volume .skPlayer-icon::before {\n          content: '';\n          display: none;\n          width: 2px;\n          height: 22px;\n          transform: rotate(58deg);\n          -webkit-transform: rotate(58deg);\n          -moz-transform: rotate(58deg);\n          -ms-transform: rotate(58deg);\n          background-color: #6A6B6F;\n          position: absolute;\n          top: -8px;\n          left: 5px; }\n        #skPlayer .skPlayer-control .skPlayer-volume .skPlayer-icon::after {\n          content: '';\n          display: block;\n          width: 5px;\n          height: 6px;\n          border-width: 4px 5px;\n          border-style: solid;\n          border-color: transparent #6A6B6F transparent transparent;\n          position: absolute;\n          top: -4px;\n          left: -5px; }\n      #skPlayer .skPlayer-control .skPlayer-volume .skPlayer-percent {\n        position: absolute;\n        width: 120px;\n        height: 14px;\n        background-color: #EBEBF2;\n        border-radius: 6px;\n        overflow: hidden;\n        cursor: pointer;\n        top: 0;\n        left: 0; }\n      #skPlayer .skPlayer-control .skPlayer-volume .skPlayer-line {\n        height: 100%;\n        width: 100%;\n        background-color: #D94240;\n        transition: 0.37s;\n        -webkit-transition: 0.37s;\n        -moz-transition: 0.37s; }\n    #skPlayer .skPlayer-control .skPlayer-list-switch {\n      display: block;\n      width: 16px;\n      height: 15px;\n      position: absolute;\n      right: 15px;\n      bottom: 12px;\n      cursor: pointer; }\n    #skPlayer .skPlayer-control .skPlayer-list-icon {\n      display: block;\n      width: 16px;\n      height: 3px;\n      background-color: #6A6B6F;\n      position: absolute;\n      right: 0;\n      bottom: 6px; }\n      #skPlayer .skPlayer-control .skPlayer-list-icon::before {\n        content: '';\n        display: block;\n        width: 16px;\n        height: 3px;\n        background-color: #6A6B6F;\n        position: absolute;\n        left: 0;\n        bottom: 6px; }\n      #skPlayer .skPlayer-control .skPlayer-list-icon::after {\n        content: '';\n        display: block;\n        width: 16px;\n        height: 3px;\n        background-color: #6A6B6F;\n        position: absolute;\n        left: 0;\n        bottom: -6px; }\n    #skPlayer .skPlayer-control .skPlayer-mode {\n      display: block;\n      width: 16px;\n      height: 17px;\n      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAABVklEQVQ4y5XTvY6NURQG4OdsnElMFFqFiCgk/htBaFAoRq0QHYO9JTsSVyB6+STfx4hO5QJMZTQkU0gw4gJM4wpIxH8x6+QMxndy3mZl7bXf911r/wwgl/oCJ/2Ll13bnNKDpB8nJtTXBMJlBi1+TjLIpW7+Y0MudYinKPiOeziObRuQL2Epl7oVRkp3cRYfMde1zZv/OA9xBzuDc3WQS92HlXA+1rXN276Zc6mH8CrMjyRcxibcn0SO81rBQwwwn3Auak8mkdfhccQzCbsjeT2FwKjTXQk/IpmdQmBLxG8Jq5HsnUJgf8TVhOeRXJhC4GLEZwkL+IVrcUW9yKUexJUY/VHq2uZdiMxgMZd6tId8GIuxd6Frm/ejl1ixx9prvG18tXKpszgQbc9jGGPfZPyZvuI8HuDWX8afsIwbQYbTWGL8F3Rt8wXXN+j8Mz5gO3asWx/AbzMQVi2KT5GSAAAAAElFTkSuQmCC);\n      position: absolute;\n      right: 15px;\n      bottom: 51px;\n      cursor: pointer; }\n      #skPlayer .skPlayer-control .skPlayer-mode.skPlayer-mode-loop {\n        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAABa0lEQVQ4y5XTu2pVURAG4O9s9QgGC1sLEbEQvMXGG7FRCwutLcROIq4lLASfQOxlC3trbK18AFMZm0QEhcSID2Aan0BB4gWLM8cT48455G+GWWv++WfWzOpBymURM/7HUtvUF4xBZTzOT7gfJAiV3Wjwe5JAymXnPwEplz5eIuMnHuMc9naQb2Ih5bIHhpke4TK+4Grb1CtbKPfxEAeCc7uXcjmK1VA+2zb1h3E9p1xO4n2In6pwCzvwZDM55bIYE/qLtqlX8Qw9zFa4EncvOgRndI/3edhLFQ6FszxpZBswrPRghV/hTG0jwa6wPyqshXNkGwmOhV2r8Dqc6x2BS3jTcX4j7KteyuVE9LSOM/HKWyLi3xmMcbpqm/oj5gxWeT7lcnoMeRrzETvXNvWn4SYWHDbYxgdGo5VymcLxKHsW/Wj7HqPPtI5reIr7m4S/4i3uBhkuYoHRX9A29Xfc6aj8Gz5jH/ZvOO/BH1b7XciLVLbaAAAAAElFTkSuQmCC); }\n  #skPlayer .skPlayer-list {\n    display: none;\n    width: 100%;\n    position: absolute;\n    top: 100px;\n    padding-top: 6px;\n    background-color: #FFF;\n    list-style: none;\n    max-height: 171px;\n    overflow-y: auto;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12); }\n    #skPlayer .skPlayer-list li {\n      position: relative;\n      height: 32px;\n      line-height: 32px;\n      padding: 0 15px;\n      font-size: 12px;\n      border-top: 1px solid #E9E9E9;\n      cursor: pointer;\n      transition: 0.2s;\n      -webkit-transition: 0.2s;\n      -moz-transition: 0.2s;\n      overflow: hidden; }\n      #skPlayer .skPlayer-list li:hover {\n        background-color: #DDD; }\n      #skPlayer .skPlayer-list li.skPlayer-curMusic {\n        background-color: #B0B0B0; }\n        #skPlayer .skPlayer-list li.skPlayer-curMusic .skPlayer-list-sign {\n          display: block; }\n    #skPlayer .skPlayer-list::-webkit-scrollbar {\n      width: 14px; }\n    #skPlayer .skPlayer-list::-webkit-scrollbar-track {\n      border-left: 1px solid #E9E9E9; }\n    #skPlayer .skPlayer-list::-webkit-scrollbar-thumb {\n      box-shadow: inset 0 0 7px rgba(0, 0, 0, 0.3);\n      background-color: #D94240; }\n    #skPlayer .skPlayer-list .skPlayer-list-sign {\n      display: none;\n      width: 3px;\n      height: 22px;\n      position: absolute;\n      left: 0;\n      top: 5px;\n      background-color: #D94240; }\n    #skPlayer .skPlayer-list .skPlayer-list-index {\n      color: #666;\n      position: absolute;\n      left: 15px;\n      top: 0; }\n    #skPlayer .skPlayer-list .skPlayer-list-name {\n      color: #6A6B6F;\n      float: left;\n      margin-left: 24px;\n      max-width: 200px;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n    #skPlayer .skPlayer-list .skPlayer-list-author {\n      color: #666;\n      float: right;\n      max-width: 107px;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n  #skPlayer.skPlayer-list-on .skPlayer-list {\n    display: block; }\n", ""]);

// exports


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(5);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 5 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// skPlayer.min.js